import React from "react";
import AdminUrlsPanel from "@/pages/admin/AdminUrlsPanel";
import LegacyHost from "@/pages/admin/os/LegacyHost";

export default function AdminUrlsPage() {
  return (
    <LegacyHost
      title="Admin URLs"
      migratedFrom="Editorial desk · Admin URLs"
      testid="os-system-admin-urls"
    >
      <AdminUrlsPanel />
    </LegacyHost>
  );
}
